import React, { Fragment } from 'react';
import { Container, Row, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Home } from 'react-feather';
import H3 from '../Headings/H3Element';

const Breadcrumbs = (props) => {
  const { title = '', parent = '', grandparent = '', greatgrandparent = '' } = props;

  const breadcrumbItems = [];

  if (greatgrandparent) {
    breadcrumbItems.push(
      <BreadcrumbItem key="greatgrandparent">
          {greatgrandparent}
      </BreadcrumbItem>
    );
  }

  if (grandparent) {
    breadcrumbItems.push(
      <BreadcrumbItem key="grandparent">
          {grandparent}
      </BreadcrumbItem>
    );
  }

  if (parent) {
    breadcrumbItems.push(
      <BreadcrumbItem key="parent">
          {parent}
      </BreadcrumbItem>
    );
  }

  breadcrumbItems.push(
    <BreadcrumbItem key="title" active>
      {title}
    </BreadcrumbItem>
  );

  return (
    <Fragment>
      <Container fluid={true}>
        <div className="page-title">
          <Row>
            <Col xs="12" sm='6'>
              <H3>{title}</H3>
            </Col>
            <Col xs="12" sm='6'>
              <div className="breadcrumb">
                <Breadcrumb>
                  <BreadcrumbItem>
                    <Link to={`${process.env.PUBLIC_URL}/dashboard/default`}>
                      <Home />
                    </Link>
                  </BreadcrumbItem>
                  {breadcrumbItems}
                </Breadcrumb>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default Breadcrumbs;
